import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const BuoyMiniIcon = ({
  width = 22,
  color = 'black',
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
      <path
        fill={getSemanticTextColor(color)}
        fillRule="evenodd"
        d="M22 11.96c-.46 5.335-4.706 9.58-10.04 10.04v-5.085c2.541-.41 4.544-2.413 4.954-4.955zm-16.915 0c.41 2.542 2.413 4.545 4.955 4.955V22C4.706 21.54.46 17.295 0 11.96zM10.04 0v5.086c-2.542.41-4.545 2.412-4.955 4.954H0C.46 4.706 4.705.46 10.04 0zm1.92 0C17.294.46 21.54 4.706 22 10.04h-5.085c-.41-2.542-2.413-4.544-4.955-4.954z"
      />
    </svg>
  </DefaultIconWrapper>
);
